import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

export function PipelineValueModal({ open, onClose, value, setValue, onSubmit, pipelineName, totalLeads, formatBRL }) {
  return (
    <Dialog open={open} onOpenChange={(o) => { if (!o) onClose(); }}>
      <DialogContent className="max-w-xs">
        <DialogHeader>
          <DialogTitle className="text-zinc-100 text-base font-semibold">Valor da Oferta</DialogTitle>
        </DialogHeader>
        <form onSubmit={onSubmit} className="space-y-3">
          <div>
            <Label className="text-xs">Valor (R$) por lead convertido</Label>
            <Input
              data-testid="pipeline-edit-value-input"
              type="number"
              value={value}
              onChange={(e) => setValue(e.target.value)}
              placeholder="Ex: 199"
              className="h-8 text-xs"
            />
          </div>
          <p className="text-[10px] text-zinc-600">
            {pipelineName}: {totalLeads} leads x R${value || 0} = {formatBRL(totalLeads * (parseFloat(value) || 0))}
          </p>
          <Button
            data-testid="pipeline-save-value-btn"
            type="submit"
            className="w-full bg-amber-500 text-zinc-950 hover:bg-amber-600 h-8 text-xs font-semibold"
          >
            Salvar
          </Button>
        </form>
      </DialogContent>
    </Dialog>
  );
}
